import { SocieteLinkedService } from './societe-linked.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { APICONSTANTS } from '../../constants/api-constants';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HostnameService } from '../basic/hostname.service';
import { Ca1ModelDTO } from '../../dtos/ca1ModelDTO';

@Injectable()
export class Ca1Service extends SocieteLinkedService<Ca1Model> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECA1, hostnameService);
  }

  getFromSite(idSoc: number, codeSite: string): Observable<Ca1Model[]> {
    // tslint:disable-next-line
    return this.http.get<Ca1Model[]>(APICONSTANTS.URLAPI.value + this.route + 'GetFromSite?idSociete=' + idSoc + '&codeSite=' + codeSite)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  
  getFromSiteAdmin(idSoc: number, codeSite: string): Observable<Ca1Model[]> {
    // tslint:disable-next-line
    return this.http.get<Ca1Model[]>(APICONSTANTS.URLAPI.value + this.route + 'GetFromSiteAdmin?idSociete=' + idSoc + '&codeSite=' + codeSite)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  postCa1(ca1DTO: Ca1ModelDTO): Observable<Ca1Model> {
    // tslint:disable-next-line
    return this.http.post<Ca1Model>(APICONSTANTS.URLAPI.value + this.route + 'postCa1/', ca1DTO)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  updateCa1(ca1DTO: Ca1ModelDTO): Observable<Ca1Model> {
    // tslint:disable-next-line
    return this.http.post<Ca1Model>(APICONSTANTS.URLAPI.value + this.route + 'update/', ca1DTO)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

}
